module.exports = __webpack_public_path__ + "img/100.9202d829.jpg";